module.exports = __webpack_public_path__ + "img/Pokebola.571cb6e4.png";